import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: "32px 24px", textAlign: "center",
          borderRadius: 16, border: "1px solid #EDE8E1",
          background: "#fff", margin: "16px 0",
        }}>
          <div style={{ fontSize: "2rem", marginBottom: 12 }}>😔</div>
          <h3 style={{ margin: "0 0 8px", color: "#1C160E" }}>
            Something went wrong
          </h3>
          <p style={{ margin: "0 0 16px", color: "#9C8D7E", fontSize: "0.9rem" }}>
            This section ran into an error. The rest of the page still works.
          </p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              padding: "8px 20px", borderRadius: 9999,
              border: "none", background: "#1C160E", color: "#fff",
              fontWeight: 600, cursor: "pointer", fontSize: "0.85rem",
              fontFamily: "DM Sans, sans-serif",
            }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}